import { useQuery } from '@tanstack/react-query';
import { bugEvaluationApi } from '../lib/bug-evaluation-api.js';
import { queryKeys } from '../lib/query-keys.js';
import type { IpointTrendParams } from '../types/api.js';

/**
 * @graph-stack product-innovation-lab
 * @graph-domain Engineering
 * @graph-business i-point月次推移データをTanStack Query経由で取得。チーム・月数・集計基準日（起因案件リリース日 / バグ起票日）指定で月次i-point累計・バグ件数を返す
 * @graph-connects bugEvaluationApi.getIpointTrend [calls] i-point月次推移APIクライアント呼び出し
 */
export function useIpointTrend(params?: IpointTrendParams) {
  return useQuery({
    queryKey: queryKeys.bugEvaluation.ipointTrend(params),
    queryFn: () => bugEvaluationApi.getIpointTrend(params),
  });
}
